// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/ie11';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import { initContent } from './utils/contentUtils';
import { initCustomer } from './utils/customerTypeUtils';
import { initCustomerData } from './utils/customerDataUtils';
import { initCustomerEmailData } from './utils/customerEmailUtils';
import { store } from './redux';

// Load Honeycomb CSS
/* eslint-disable import/no-extraneous-dependencies */
import '@honeycomb-npm/honeycomb/src/bundles/honeycomb.scss';

// eslint-disable-next-line
(window as any).RenderApp = () => {
  initCustomer();
  initContent();
  initCustomerData();
  initCustomerEmailData();
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>, document.getElementById('root'),
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
